export default __webpack_public_path__ + "static/blockchain-1765b066bff3d67b87545a25c258a692.png";